
class PageQuestionAPI {
    update(pageQuestion) {
        const endpoint = `/api/survey/${this.surveyId}/pageQuestion/${pageQuestion.id}`
        this.store.http.put(endpoint, JSON.stringify(pageQuestion.currentOptions), this.store.surveyToken)
            .then((res) => {
                console.log(`done ${res}`)
                this.store.survey.refreshSkipLogic(this.store)
                this.store.addNotification(null, 'Question updated', 'success')
            }).catch((e) => {
                console.log(e)
                this.store.addNotification(null, `Error updating question: ${e.message}`, 'error')
            })
    }
}

export default new PageQuestionAPI()